import { PushTokens } from './PushTokens'

export const Notifications = {
  PushTokens,
}
